import { BM_LANG_CONFIG, EN_LANG_CONFIG } from "./lang";
import {BackendResponse} from "./types";
import {CONFIG} from "./config";
import {CONSTANTS} from './constants';

const getLabelValue = (language: string = 'en', key: string = '') => {
    if (language === '') return '';
    if (key === '') return '';
    if (language === 'en') return EN_LANG_CONFIG[key];
    if (language === 'bm') return BM_LANG_CONFIG[key]
    return ''
}

const logError = (title: string, error: any): void => {
    if (CONFIG.env === "test")
        console.log(`${title} :: `, error);
}

const callBackendAPI = async (
    route: string = '', method: string, headers: HeadersInit, data: any
): Promise<BackendResponse | undefined> => {
    try {
        if (route === '') return { error: 'Missing route in call'};
        let options: RequestInit = {
            method: method,
        };
        if (headers)
            options['headers'] = headers;

        if (data) {
            options['body'] = JSON.stringify(data);
        }

        let API_URL: string = CONFIG.env === "test" ? CONFIG.apiUrlTest : CONFIG.apiUrlLive;
        let response: Response = await fetch(`${API_URL}/${route}`, options);
        let results: any = await response.json();
        return { error: undefined, results }
    } catch (e: any) {
        logError('Error callBackendAPI', e);
        return { error: e.toString() }
    }
}

const numberWithCommas = (x: number) => {
    if (x === undefined)  return '';
    let parts: string[] = x.toFixed(2).toString().split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return parts.join('.');
}

const getSignatureFromUrl = (url: string): string => {
    try {
        const parts = url.split('/');
        const signature = parts[parts.length - 1];

        return signature || ''
    } catch (error) {
        logError("Error extracting signature:", error);
        return "";
    }
}

const stripCharactersAndTrim = (value: string, searchValue: string, replaceValue: string): string => {
    if (value === '') return value;
    return value.replace(searchValue, replaceValue).trim();
}

const getDocumentType = (value: string): string => {
    /// 01 = Invoice, 02 = Credit Note, 03 = Debit Note, 04 = Refund Note,
    // 11 = Self Billed Invoice, 12 = Self Billed Credit Note, 13 = Self Billed Debit Note, 14 = Self Billed Refund Note
    switch (value) {
        case "01":
            return 'Invoice';
        case "02":
            return 'Credit Note';
        case "03":
            return 'Debit Note';
        case "04":
            return 'Refund Note';
        case "11":
            return 'Self Billed Invoice';
        case "12":
            return 'Self Billed Credit Note';
        case "13":
            return 'Self Billed Debit Note';
        case "14":
            return 'Self Billed Refund Note';
        default:
            return '';
    }
}

const verifyEmail = (email: string = ''): boolean => {
    if (email === '') return true;
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.toLowerCase());
};


const getStateByCode = (code: string): string => {
    return CONSTANTS.STATE_CODES?.find(i => i?.Code === code)?.State || ''
}


export {
    getLabelValue,
    callBackendAPI,
    logError,
    numberWithCommas,
    getSignatureFromUrl,
    stripCharactersAndTrim,
    getDocumentType,
    verifyEmail,
    getStateByCode
}
